import { APP_CONTEXT } from 'src/app/modules/core/models/app-state';
import { VEHICLE_COLOR_RGB, VEHICLE_ICON } from './vehicle-icons-enum';
import { marker as _translate } from '@biesbjerg/ngx-translate-extract-marker';

export class VehiclePunctualityConfig {
    context: APP_CONTEXT = APP_CONTEXT.PUNCTUALITY;
    early = 15; // if more than 15 seconds early = early
    onTime: number = -1 * 60; // max 1 minute late
    lateLevel1: number = -6 * 60;
    lateLevel2: number = -9 * 60;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }

    public getArrivalConfig(arrivalSeconds: number = null): {
        color: VEHICLE_COLOR_RGB;
        icon: VEHICLE_ICON;
        text: string;
    } {
        if (arrivalSeconds === null || arrivalSeconds === undefined) {
            return {
                color: VEHICLE_COLOR_RGB.Gray,
                icon: VEHICLE_ICON.Default,
                text: undefined,
            };
        }

        return this._arrivalConfig(arrivalSeconds);
    }

    public getConfig(
        departureSeconds: number,
        arrivalSeconds: number = null,
        onTomLayOvr: boolean = false,
    ): { color: VEHICLE_COLOR_RGB; icon: VEHICLE_ICON; text: string } {
        if (onTomLayOvr) {
            return {
                color: VEHICLE_COLOR_RGB.Blue,
                icon: VEHICLE_ICON.OnTomLayovr,
                text: _translate('On TOM-LAYOVR'),
            };
        }

        const hasArrival =
            arrivalSeconds !== null && arrivalSeconds !== undefined;

        if (departureSeconds === undefined && !hasArrival) {
            return {
                color: VEHICLE_COLOR_RGB.Gray,
                icon: VEHICLE_ICON.Default,
                text: undefined,
            };
        }

        if (!hasArrival) {
            return this._departureConfig(departureSeconds);
        } else if (departureSeconds === undefined) {
            return this._arrivalConfig(arrivalSeconds);
        } else if (departureSeconds > arrivalSeconds) {
            return this._arrivalConfig(arrivalSeconds);
        } else {
            return this._departureConfig(departureSeconds);
        }
    }

    private _departureConfig(seconds) {
        let color = VEHICLE_COLOR_RGB.Gray;
        let icon = VEHICLE_ICON.Default;
        let text;

        if (seconds > this.early) {
            color = VEHICLE_COLOR_RGB.Red;
            icon = VEHICLE_ICON.Early;
            text = _translate('Early');
        } else if (seconds <= this.early && seconds > this.onTime) {
            color = VEHICLE_COLOR_RGB.Green;
            icon = VEHICLE_ICON.OnTime;
            text = _translate('On time');
        } else if (seconds <= this.onTime && seconds > this.lateLevel1) {
            color = VEHICLE_COLOR_RGB.Yellow;
            icon = VEHICLE_ICON.Late_level1;
            text = _translate('Late');
        } else if (seconds <= this.lateLevel1 && seconds > this.lateLevel2) {
            color = VEHICLE_COLOR_RGB.Orange;
            icon = VEHICLE_ICON.Late_level2;
            text = _translate('More late');
        } else if (seconds <= this.lateLevel2) {
            color = VEHICLE_COLOR_RGB.Pink;
            icon = VEHICLE_ICON.Late_level3;
            text = _translate('Most late');
        }

        return { color, icon, text };
    }

    private _arrivalConfig(seconds) {
        let color = VEHICLE_COLOR_RGB.Gray;
        let icon = VEHICLE_ICON.Default;
        let text;

        if (seconds > this.early) {
            color = VEHICLE_COLOR_RGB.Red;
            icon = VEHICLE_ICON.Early;
            text = _translate('Early');
        } else if (seconds <= this.onTime && seconds > this.lateLevel1) {
            color = VEHICLE_COLOR_RGB.Yellow;
            icon = VEHICLE_ICON.Late_level1;
            text = _translate('Late');
        } else if (seconds <= this.lateLevel1 && seconds > this.lateLevel2) {
            color = VEHICLE_COLOR_RGB.Orange;
            icon = VEHICLE_ICON.Late_level2;
            text = _translate('More late');
        } else if (seconds <= this.lateLevel2) {
            color = VEHICLE_COLOR_RGB.Pink;
            icon = VEHICLE_ICON.Late_level3;
            text = _translate('Most late');
        } else {
            color = VEHICLE_COLOR_RGB.Green;
            icon = VEHICLE_ICON.OnTime;
            text = _translate('On time');
        }

        return { color, icon, text };
    }
}
